import {
  GET_EXCEPTION_LOG_FAILURE,
  GET_EXCEPTION_LOG_REQUEST,
  GET_EXCEPTION_LOG_SUCCESS,
} from "./ActionType";

const initialState = {
  log: {},
  loading: false,
  error: null,
};

export const exceptionLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXCEPTION_LOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EXCEPTION_LOG_SUCCESS:
      return {
        ...state,
        log: action.payload,
        loading: false,
        error: null,
      };
    case GET_EXCEPTION_LOG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
